import ModalWindow from "components/ModalWindow";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import BuyWidget from "./BuyWidget";
import { useState } from "react";

const BuyWidgetPopup = ({ close }) => {
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  return (
    <ModalWindow close={close}>
      <div
        className="modal-window__wrapper modal-window__wrapper--add-funds"
        onClick={(e) => e.stopPropagation()}
      >
        <PagePopopCloseButton close={close} />
        {isTermsAccepted === false ? (
          <>
            <p className="add-funds__text">
              <span className="yellow">
                TwoTwentyK uses cryptocurrency called Stablecoins for in game
                purchases.
              </span>
              <span>
                To make a purchase, you may be asked to provide
                documents to confirm your identity. Once confirmed you will be
                able to fund your wallet. Note - the third-party charges a
                service fee. It will be clearly displayed prior to you
                completing your purchase.
              </span>
              <span>
                We recognize this process isn't ideal. We are working on other
                options to make this easier.
              </span>
              <span>Thank you for your understanding.</span>
            </p>
            <footer className="modal-window__footer">
              <button className="modal-window__footer-submit" onClick={() => setIsTermsAccepted(!isTermsAccepted)}>Confirm</button>
            </footer>
          </>
        ) : (
          <BuyWidget />
        )}
      </div>
    </ModalWindow>
  );
};

export default BuyWidgetPopup;
